import { saveAs } from "file-saver";
import { toBlob } from "./Canvas";

/**
 *
 * @param {Blob|File|String|HTMLCanvasElement} data
 * @param {String} fileName
 */
export async function saveFile(data, fileName) {
  const convertedData = await convertData(data);
  saveAs(convertedData, fileName);
}

async function convertData(data) {
  if (data instanceof HTMLCanvasElement) {
    const output = await toBlob(data);

    return output;
  } else {
    return data;
  }
}
